import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grow from '@material-ui/core/Grow';
import Fade from '@material-ui/core/Fade';
import classNames from 'classnames';

import * as actions from '../actions';

const styles = (theme) => ({
	root: {
		paddingTop: theme.spacing.unit * 12,
		paddingBottom: theme.spacing.unit * 12,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		overflow: 'hidden'
	},
	text: {
		marginBottom: theme.spacing.unit * 5,
		textAlign: 'center'
	},
	button: {
		fontSize: 18,
		paddingLeft: theme.spacing.unit * 3,
		paddingRight: theme.spacing.unit * 3,
		paddingTop: theme.spacing.unit * 1.5,
		paddingBottom: theme.spacing.unit * 1.5,
	},
});

class Results extends Component {
	componentDidMount(nextProps) {
		const { exContainer, testMode } = this.props;

		if (testMode) {
			window.nl_loader.getTestAdmin().showButtons(exContainer);
		}
	}

	componentWillUnmount() {
		const { exContainer, testMode } = this.props;

		if (testMode) {
			window.nl_loader.getTestAdmin().hideButtons(exContainer);
		}
	}

	render() {
		const { classes, text, textSecondary, restartExercise, resultsVisible, showStartAgain } = this.props;

		return (
			<div className={classNames(classes.root)}>
				<Grow timeout={1000} in={resultsVisible}>
					<div>
						<Typography variant="display1" gutterBottom className={classes.text} color="textSecondary" dangerouslySetInnerHTML={{ __html: text }} />
						{
							textSecondary && (
								<Typography
									variant="headline"
									gutterBottom
									className={classes.text}
									color="textSecondary"
									dangerouslySetInnerHTML={{ __html: textSecondary }}
								/>
							)
						}
					</div>
				</Grow>
				<Fade in={resultsVisible} style={{ transitionDelay: 700, visibility: showStartAgain ? 'block' : 'hidden' }}>
					<Button variant="raised" color="primary" className={classNames('theme-background', 'theme-hover', classes.button)} onClick={restartExercise}>
						Start again
					</Button>
				</Fade>
			</div >
		);
	}
}

Results.propTypes = {
	classes: PropTypes.object.isRequired,
	text: PropTypes.string.isRequired,
	textSecondary: PropTypes.string,
	itemsLength: PropTypes.number.isRequired, // eslint-disable-line
	restartExercise: PropTypes.func.isRequired,
	resultsVisible: PropTypes.bool.isRequired,
	testMode: PropTypes.string,
	exContainer: PropTypes.object,
	showStartAgain: PropTypes.bool,
};

Results.defaultProps = {
	testMode: undefined,
	exContainer: undefined,
	showStartAgain: false,
	textSecondary: undefined
};

function mapStateToProps({ exercise, loader }, ownProps) {
	return {
		wordsPerMinute: exercise.wordsPerMinute,
		wordsRecognisedPercent: exercise.wordsRecognisedPercent,
		itemsLength: exercise.items.length,
		resultsVisible: exercise.resultsVisible,
		exContainer: loader.exContainer,
		testMode: loader.testMode,
		testSent: loader.testSent
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps, actions),
	withProps(ownProps => {
		let wordsRecognisedFeedback;

		if (ownProps.wordsRecognisedPercent > 80) {
			wordsRecognisedFeedback = 'What you said matched the text very well.';
		} else if (ownProps.wordsRecognisedPercent > 60) {
			wordsRecognisedFeedback = 'What you said matched the text quite well.';
		} else {
			wordsRecognisedFeedback = 'What you said didn\'t match the text very well.';
		}

		const metricsText = `
			Rate: <b>${ownProps.wordsPerMinute}</b> words per minute.<br>
			${ownProps.wordsPerMinute < 100 ? 'This is a bit slow.' : 'This is a good speaking rate.'}<br><br>
			Words recognised: <b>${ownProps.wordsRecognisedPercent}%</b><br>
			${wordsRecognisedFeedback}
		`;

		if (ownProps.testMode) {
			if (ownProps.testSent) {
				return {
					text: 'You\'ve finished the test.',
					textSecondary: metricsText,
				};
			}
			return {
				text: 'You\'ve finished the test',
				textSecondary: 'Please, submit your results when you\'re ready.'
			};
		}
		return {
			text: 'Your results are:',
			textSecondary: metricsText,
			showStartAgain: true
		};
	})
)(Results);
